import mobile from 'is-mobile';
import striptags from 'striptags';
import ent from 'ent';
import get from 'lodash/get';
import isNull from 'lodash/isNull';
import isEmpty from 'lodash/isEmpty';
import some from 'lodash/some';
import forEach from 'lodash/forEach';

import * as dateTime from './datetime';

export const debounce = (func, wait, immediate) => {
  let timeout;
  return (...args) => {
    const context = this;
    const later = () => {
      timeout = null;
      if (!immediate) Reflect.apply(func, context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) Reflect.apply(func, context, args);
  };
};

export const guid = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };

  return `${s4()}-${s4()}-${s4()}-${s4()}`;
};

const isDeviceiOS = () => {
  if (!window || !navigator) return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const isMobile = () => {
  return mobile() || isDeviceiOS();
};

export const isNowInsideBillingHours = ({ hours, timezoneOffset }) => {
  const offset = timezoneOffset || 0;

  const adjustedDate = dateTime.adjustDateWithOffset(offset);

  const day = adjustedDate.getDay();

  const hoursOfDay = get(hours, day);

  if (isNull(hoursOfDay) || isEmpty(hoursOfDay)) {
    return false;
  }

  const h = adjustedDate.getHours();
  const minutes = adjustedDate.getMinutes();
  const totalMinutes = h * 60 + minutes; // eslint-disable-line no-mixed-operators
  return some(hoursOfDay, ([start, end]) => totalMinutes >= start && totalMinutes < end);
};

export const isNowAHoliday = holidays => {
  const today = Date.now();
  if (isNull(holidays) || isEmpty(holidays)) {
    return false;
  }

  return some(holidays, holiday => {
    if (!holiday.enabled) return false;

    const start = new Date(holiday.startDate).valueOf();
    const end = new Date(holiday.endDate).valueOf();

    return today > start && today < end;
  });
};

export const createFormData = (fields, file) => {
  const data = new FormData();
  forEach(fields, (value, key) => data.append(key, value));
  data.append('file', file);
  return data;
};

export const getMillisSinceLastActivity = (activity = 0) => {
  return Date.now() - activity;
};

export const cleanBody = body => {
  let cleanedBody = body.replace(/&nbsp;/g, ' ');
  cleanedBody = ent.decode(cleanedBody);
  cleanedBody = striptags(cleanedBody);

  if (cleanedBody.trim().length === 0) return '';

  return cleanedBody;
};
